import { render } from "./status-desktop.vue?vue&type=template&id=4b7bb402&scoped=true"
import script from "./status-desktop.vue?vue&type=script&lang=js"
export * from "./status-desktop.vue?vue&type=script&lang=js"

import "./status-desktop.vue?vue&type=style&index=0&id=4b7bb402&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7bb402"]])

export default __exports__